import { createEnumOptions } from '@/utils/core/data-transformation/enumHelpers';
import { CoreEnums } from '@/utils/domain/constants';

const ACCESS_POLICY_DEFINITION_RULE_FIELDS = Object.freeze([
  {
    name: 'ruleType',
    label: 'accessPolicy.definition.ruleType',
    type: 'select',
    width: 200,
    options: createEnumOptions(CoreEnums.CompanyAccessPolicyRuleType, 'accessPolicy.ruleType', {
      casing: 'camel',
    }),
    rules: [{ required: true, message: 'form.error.required' }],
  },
  {
    name: 'operator',
    label: 'accessPolicy.definition.operator',
    type: 'select',
    width: 200,
    options: createEnumOptions(CoreEnums.ComparisonOperator, 'accessPolicy.operator', {
      casing: 'camel',
    }),
    rules: [{ required: true, message: 'form.error.required' }],
  },
  {
    name: 'values',
    label: 'accessPolicy.definition.values',
    type: 'text',
    width: 320,
    rules: [{ required: false }],
  },
]);

/**
 * Config passed to shared DefinitionGroupsEditor for company access policy definition.groups.
 */
export const ACCESS_POLICY_DEFINITION_GROUPS_EDITOR_CONFIG = Object.freeze({
  maxDepth: 4,
  groupDefaults: Object.freeze({
    logicalOperator: CoreEnums.LogicalOperator.And,
    rules: [],
    groups: [],
  }),
  ruleDefaults: Object.freeze({
    ruleType: CoreEnums.CompanyAccessPolicyRuleType.ScopeRole,
    operator: CoreEnums.ComparisonOperator.Equal,
    values: '',
  }),
  logicalOperatorOptions: Object.freeze(
    createEnumOptions(CoreEnums.LogicalOperator, 'global.field', { casing: 'lower' }),
  ),
  ruleFields: ACCESS_POLICY_DEFINITION_RULE_FIELDS,
  labelIds: Object.freeze({
    logicalOperator: 'accessPolicy.definition.logicalOperator',
    rules: 'accessPolicy.definition.rules',
    groups: 'accessPolicy.definition.groups',
    groupTitle: 'accessPolicy.definition.groupTitle',
  }),
});
